import React from 'react';
import { Link } from 'react-router-dom';

import SectionHeader from '../../shared/section-header';

import style from './index.module.scss';

function AnswerRequests() {
  const { header, answer, img, title, actions, action } = style;

  return (
    <>
      <div className={header}>
        <SectionHeader headingLeft='Answer Requests' colWidth={12} />
      </div>
      {[1, 2, 3, 4].map(x => (
        <div className={`card ${answer}`} key={x}>
          <div className={`col-12 ${style['col--user']}`}>
            <Link to='/account/profile'>
              <img
                src='https://i.imgur.com/qHpJwKV.jpg'
                alt='Collins Orlando'
                className={img}
              />
            </Link>
            <p className={style['requested-by']}>
              <Link to='/account/profile' className={style['user-link']}>
                Collins Orlando
              </Link>{' '}
              requested your answer to this · {'4 d'} ago
            </p>
          </div>
          <h4 className={title}>
            How many years do we likely have left on this planet?
          </h4>
          <div className={`col-12 ${style['col--actions']}`}>
            <div className={`${actions} ${style['actions--left']}`}>
              <span className={action}>
                <i className='fas fa-edit' /> Answer
              </span>
              <span className={action}>
                <i className='fas fa-times' /> Pass
              </span>
            </div>
            <div className={`${actions} ${style['actions--right']}`}>
              <span className={action}>
                <i className='fas fa-edit' />
              </span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default AnswerRequests;
